"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M10.694 10.003h1.62c.547 0 .992.445.992.992v2.01a.993.993 0 01-.992.992h-1.62v-3.994z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12a6 6 0 1112 0 6 6 0 01-12 0zm6.314 2.931a1.926 1.926 0 001.926-1.926v-2.01a1.926 1.926 0 00-1.926-1.926H9.76v5.862h2.554z" })), "DLCs");
//# sourceMappingURL=DLC.js.map